/**
 * src/admin-ui/src/pages/Login.tsx
 *
 * Application gateway to native Keycloak login and registration.
 */
import React from "react";
import { Alert, CircularProgress, Typography } from "@mui/material";
import {
  LockOutlined,
  LoginOutlined,
  PersonAddOutlined,
} from "@mui/icons-material";
import { Navigate, useLocation } from "react-router-dom";

import ThemeToggle from "../components/ThemeToggle";
import { useAuthStore } from "../store/authStore";
import {
  Brand,
  HelperText,
  LoginBottomBar,
  LoginPaper,
  LoginViewport,
  SubmitButton,
} from "./Login.styles";

const Login: React.FC = () => {
  const { isAuthenticated, loading, error, login, register } = useAuthStore();
  const location = useLocation();

  if (loading) {
    return (
      <LoginViewport>
        <CircularProgress size={60} />
      </LoginViewport>
    );
  }

  if (isAuthenticated) {
    const target = (location.state as { from?: { pathname?: string } } | null)
      ?.from?.pathname;
    return <Navigate to={target || "/dashboard"} replace />;
  }

  return (
    <>
      <LoginViewport>
        <LoginPaper elevation={8}>
          <Brand>
            <LockOutlined />
            <Typography variant="h4" component="h1">
              api-bar
            </Typography>
          </Brand>

          {error && <Alert severity="error">{error}</Alert>}

          <SubmitButton
            type="button"
            variant="contained"
            size="large"
            fullWidth
            startIcon={<LoginOutlined />}
            onClick={() => void login("/dashboard")}
          >
            Войти
          </SubmitButton>

          <SubmitButton
            type="button"
            variant="outlined"
            size="large"
            fullWidth
            startIcon={<PersonAddOutlined />}
            onClick={() => void register()}
          >
            Зарегистрироваться
          </SubmitButton>

          <HelperText variant="body2" color="text.secondary">
            Пароль вводится только в Keycloak. После регистрации подтвердите
            адрес электронной почты.
          </HelperText>
        </LoginPaper>
      </LoginViewport>

      <LoginBottomBar>
        <ThemeToggle />
      </LoginBottomBar>
    </>
  );
};

export default Login;
